import { render, staticRenderFns } from "./package-map-widget.vue?vue&type=template&id=8f25d9d2&"
import script from "./package-map-widget.vue?vue&type=script&lang=js&"
export * from "./package-map-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports